import { enableOnlyIssueId } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/timeline/schedule/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default { enableOnlyIssueId };
